import { useFilter } from './useFilter'
import { JsonFormSchemaV2 } from '../../component-library/FormComponent/types'
import { useSessionStorage } from '@/hooks'
import { InferFormValues } from '../../component-library/FormComponent/types'
import { TPageFilter } from '../types'
import { useFiltersLayout } from '../FiltersLayoutContext'
import { FormContentV2 } from '../../component-library/FormComponent/FormContentV2'

type FormFilterContentProps = {
  filter?: TPageFilter
  isConfiguringLayout: boolean
}

export function FormFilterContent({ filter, isConfiguringLayout }: FormFilterContentProps) {
  const { data } = useFilter(filter)
  const { unPinnedFilters, pinFilter } = useFiltersLayout()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filterSelectionsPersisted, setFiltersSelectionsPersisted] = useSessionStorage<Record<string, any>[] | ''>(
    data.storageKey,
    ''
  )
  const defaultsFromPersisted: InferFormValues<JsonFormSchemaV2> | undefined =
    filterSelectionsPersisted && data.type === 'filter' ? Object.assign({}, ...filterSelectionsPersisted) : undefined

  return (
    <FormContentV2
      submitHandler={(data: InferFormValues<JsonFormSchemaV2>) => {
        setFiltersSelectionsPersisted(
          Object.entries(data).map(([key, value]) => ({
            [key]: value,
          }))
        )
      }}
      schema={data.data}
      filterType="unPinned"
      isConfiguringLayout={isConfiguringLayout}
      resetDefaults={defaultsFromPersisted}
      pinFilter={pinFilter}
      unPinnedFilters={unPinnedFilters}
    />
  )
}
